import { render, staticRenderFns } from "./matchModal.vue?vue&type=template&id=c512a99c&scoped=true&"
import script from "./matchModal.vue?vue&type=script&lang=js&"
export * from "./matchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c512a99c",
  null
  
)

export default component.exports